var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "_component-side-helper-mobile" },
        [
          _vm.isShowServe
            ? _c("Serve", {
                staticClass: "bar-pop",
                on: { close: _vm.triggerServe }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "trigger-wrap img-wrap",
              on: { click: _vm.triggerServe }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "//hsylc.oss-cn-hangzhou.aliyuncs.com/2025/icons/online-helper.png",
                  alt: ""
                }
              })
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }